import React, { useReducer, createContext } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import Divider from '@material-ui/core/Divider';
import DriversActionsButtons from './DriversActionsButtons';
import { __ } from '../../../../../utils/i18n';
import DriversSearchBox from './DriversSearchBox';
import DriversList from './DriversList';
import { makeStyles } from '@material-ui/core/styles';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap:16
  },
}));

export const store = createContext(null);
const { Provider } = store;

const Drivers = () => {
  useTitle('مدیریت رانندگان ')
  const classes = useStyles();
  return (
      <FullCard title="مدیریت رانندگان" actions={<DriversActionsButtons />}>
        <div className={classes.root}>
          <DriversSearchBox />
          <Divider />
          <DriversList />
        </div>
      </FullCard>
  );
};

export default React.memo(Drivers);
